import React from 'react'
import "./CodingTraining1.css"

import _codingtraining_1         from "../../assets/codingtraining/_codingtraining_1.avif"
import _codingtraining_2         from "../../assets/codingtraining/_codingtraining_2.avif"
import _codingtraining_3         from "../../assets/codingtraining/_codingtraining_3.avif"
import _codingtraining_4         from "../../assets/codingtraining/_codingtraining_4.avif"
import _codingtraining_5         from "../../assets/codingtraining/_codingtraining_5.avif"
import _codingtraining_6         from "../../assets/codingtraining/_codingtraining_6.avif"
import _codingtraining_7         from "../../assets/codingtraining/_codingtraining_7.avif"
import _codingtraining_8         from "../../assets/codingtraining/_codingtraining_8.avif"




import Title from '../_title/Title'

export const appAndProjectDatabase1 = [
  {
      id: 1,
      image: _codingtraining_1,
      title: "Interactive Coding Foundations for Students",
      abstract: "Equip JHS and SHS students with hands-on skills in Python, JavaScript, HTML, and more through engaging, practical tutorials designed for beginners. Build the confidence to create apps, websites, and digital tools from scratch.",
  },
  {
      id: 2,
      image: _codingtraining_2,
      title: "Artificial Intelligence for the Next Generation",
      abstract: "Introduce students to AI fundamentals, from machine learning basics to real-world applications. Spark curiosity in data-driven problem-solving and inspire them to design smart solutions for their communities.",
  },
  {
      id: 3,
      image: _codingtraining_3,
      title: "Teacher Capacity Building & Digital Resource Development",
      abstract: "Empower teachers with high-quality resources, modern teaching strategies, and technical skills to deliver world-class coding and AI training to their students, ensuring a sustainable impact beyond 2027.",
  },
    {
      id: 4,
      image: _codingtraining_4,
      title: "Student Certification & Career Pathways",
      abstract: "Provide a clear learning progression with beginner-to-advanced certifications, helping students build portfolios and credentials that open doors to jobs, internships, and higher education opportunities.",
  },
  {
      id: 5,
      image: _codingtraining_5,
      title: "Coding for Local Innovation & Entrepreneurship",
      abstract: "Encourage students to build homegrown solutions to local problems. Support creative coding projects that can transform into startups, tech products, or community-driven innovations.",
  },
  {
      id: 6,
      image: _codingtraining_6,
      title: "Building a Future-Ready Workforce",
      abstract: "Develop globally competitive skills among the youth to prepare them for careers in software development, data science, cybersecurity, and digital design, creating pathways to remote and international employment.",
  },
    {
      id: 7,
      image: _codingtraining_7,
      title: "Supporting Economic Transformation through Digital Skills",
      abstract: "Show students and their families how coding and AI can generate income, contribute to a country’s GDP, and reduce youth unemployment by creating high-demand skills within local communities.",
  },
  {
      id: 8,
      image: _codingtraining_8,
      title: "Enabling Inclusive & Equitable Digital Access",
      abstract: "Ensure that every child, regardless of background or location, has the opportunity to learn, create, and lead with technology. Break down barriers so even rural or underserved students can thrive in the digital economy.",
  }
];



const CodingTraining1 = () => {
  return (
    <div className="codingtraining-1-main-container-1">
      <div className="codingtraining-1-sub-container-2">
        <Title title="Vision-2027"/>
        <Title title="Nationwide Coding, AI & Digital Skills Program (JHS & SHS Focus)"/>
        <div className='codingtraining-1-sub-container-3'>
          <h2>
            This program aims to build a future-ready, digitally skilled generation by providing Junior and Senior High Schools students with hands-on coding and AI education, covering beginner to advanced skills in Python, JavaScript, HTML, and machine learning. It also focuses on empowering teachers with modern resources and strategies, establishing clear certification pathways for students, and fostering local innovation and entrepreneurship.
          </h2>
        </div>

        <div className='codingtraining-1-sub-container-4'>
            {appAndProjectDatabase1.map((program, index) => (
              <CodingTraining1DisplayData key={program.id} program={program} index={index} />
            ))}
        </div>

    </div>
    </div>
  )
}


const CodingTraining1DisplayData = ({ program, index }) => {
  const backgroundClass =
    index === 0 || index === 3 ? "bg-style-1"   
      : "bg-style-2"; 

  return (
    <div className={`codingtraining-1-display-container-5 ${backgroundClass}`}>
      <img src={program.image} alt="" />
      <div className="codingtraining-1-display-container-6">
        <h4>{program.title}</h4>
        <h2>{program.abstract}</h2>
      </div>
    </div>
  );
};

export default CodingTraining1